import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=78c9275a&scoped=true&"
import script from "./TabNavigation.vue?vue&type=script&lang=js&"
export * from "./TabNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=78c9275a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9275a",
  null
  
)

export default component.exports